module.exports = __webpack_public_path__ + "static/img/inventario_cajas.4e254d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_cajas.png
// module id = 91
// module chunks = 0